import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'

import ASplitter from './ASplitter'
import Map from './Map'
import TopFilters from './TopFilters'
import Deenergized from './Deenergized'
import FireReg from './FireReg'
import WeatherReg from './WeatherReg'
import MapFilters, { test } from './MapFilters'
import Table from './Table'
import TotalInfo from './TotalInfo'
import Graph from './Graph'
import './App.css'
import { _ENV, _MAP_TYPES, decoration } from './Settings'
import { DataService } from './DataService'
import { existed, priority_colors, industry_icon, datetime, date, daystime, oktmo2name, code2region, midDuration, objDBTable, fixHtml } from './Utils'

import { Panel } from 'primereact/panel'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { Badge } from 'primereact/badge'
import { Accordion, AccordionTab } from 'primereact/accordion'

const ENV = _ENV.PROD

export default function App() {
	
	ENV.init()
	
	const mapRef = useRef()
	const topFiltersRef = useRef()
	const mapFiltersRef = useRef()
	const DS = new DataService(topFiltersRef)
	const mapHeight = () => DS.data.useCustomViewport ? DS.data.customViewportHeight : mapType.MAP_HEIGHT
	
	const [mapType, setMapType] = useState(_MAP_TYPES.MERC)
	const [mapDivHeight, setMapDivHeight] = useState(mapType.MAP_HEIGHT)
	const [mapScale, setMapScale] = useState(1)
	
	const setupMapScale = () => {
		/*
		let dw = 0
		const settingwWindow = document.querySelector('.inmap-filter .map-settings .p-panel-content')
		if (settingwWindow) {
			const rect = settingwWindow.getBoundingClientRect()
			dw = rect.right - rect.left + 40
		}
		*/
		const dw = 0
		const width = window.innerWidth
			|| document.documentElement.clientWidth
			|| document.body.clientWidth
		const height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight
		const _scale = Math.min(1, (width - dw)/(DS.data.useCustomViewport ? DS.data.customViewportWidth : mapType.MAP_WIDTH), height/mapHeight())
		setMapScale(_scale)
		document.documentElement.style.setProperty('--map-scale', _scale)
	}
	
	useEffect(() => {
		setupMapScale()
		window.addEventListener('resize', setupMapScale, true)
		window.onscroll = (e) => {
			document.documentElement.style.setProperty('--window-scroll', window.scrollY)
		}
		if (ENV.refresh) setInterval(() => topFiltersRef.current.reloadData(), ENV.refresh * 60000)
	}, [])
	
	
	
	/*
	 * Dialogs
	 */
	
	const [dialogs, setDialogs] = useState([])
	let _justClosed = null
	const deenergizedId = 'deenergized_'
	const fireRegId = 'fireReg_'
	const weatherRegId = 'weatherReg_'
	
	const onShowEventDetails = (ids) => {
		let ex = existed(dialogs, ids)
		if (ex) {
			DS.setters.setActiveEvents([...dialogs.filter(e => e !== ex).map(e => e.active), ids[0]])
			DS.loadShutoffs([ids[0]])
			const refresh = ex.active !== ids[0]
			if (refresh) ex = Object.assign({}, ex, {active: ids[0]})
			onDialogBringToFront(ex, refresh)
		} else {
			const sorted = DS.data.events.filter(e => ids.includes(e.id)).sort((a, b) => b.ds - a.ds).map(e => e.id)
			if (!ids[0].startsWith(deenergizedId)) {
				DS.setters.setActiveEvents([...dialogs.filter(e => !e.active.startsWith(deenergizedId)).map(e => e.active), sorted[0]])
				DS.loadShutoffs([sorted[0]])
			} else if (!ids[0].startsWith(fireRegId)) {
			}
			setDialogs([{ids: sorted, active: sorted[0]}, ...dialogs])
		}
		setDragEvent(ids)
	}
	
	const onShowObject = (objuuid) => {
		dialogs[0].objuuid = objuuid
		setDialogs([...dialogs])
	}
		
	const onDialogBringToFront = (d, refresh = false) => {
		if (refresh) {
			setDialogs([d, ...dialogs.filter(e => e.ids !== d.ids)])
		} else if (dialogs[0].ids !== d.ids && d.ids !== _justClosed) {
			setDialogs([dialogs.find(e => e.ids === d.ids), ...dialogs.filter(e => e.ids !== d.ids)])
		}
	}
	
	const onShowDialog = (d) => {
		if (!existed(dialogs, d.ids)) {
			setDialogs([{ids: d.ids, active: d.ids[0]}, ...dialogs])
		}
	}
	
	const onCloseDialog = (d) => {
		if (!d.ids[0].startsWith(deenergizedId)) {
			DS.setters.setActiveEvents(dialogs.filter(e => !e.active.startsWith(deenergizedId) && e.active !== d.active).map(e => e.active))
		} else if (!d.ids[0].startsWith(fireRegId)) {
		}
		_justClosed = d.ids
		setDialogs(dialogs.filter(e => !existed([e], d.ids)))
	}
	
	const onShowDeenergized = (reg) => {
		if (!existed(dialogs, [deenergizedId + reg])) {
			setDialogs([{ids: [deenergizedId + reg], active: deenergizedId + reg}, ...dialogs])
		} else {
			onDialogBringToFront(dialogs.find(e => e.ids[0] === deenergizedId + reg))
		}
	}
	
	const onShowFireReg = (reg) => {
		if (!existed(dialogs, [fireRegId + reg])) {
			setDialogs([{ids: [fireRegId + reg], active: fireRegId + reg}, ...dialogs])
		} else {
			onDialogBringToFront(dialogs.find(e => e.ids[0] === fireRegId + reg))
		}
	}
	
	const onShowWeatherReg = (reg) => {
		//console.log(reg)
		if (!existed(dialogs, [weatherRegId + reg])) {
			setDialogs([{ids: [weatherRegId + reg], active: weatherRegId + reg}, ...dialogs])
		} else {
			onDialogBringToFront(dialogs.find(e => e.ids[0] === weatherRegId + reg))
		}
		
	}
	
	useEffect(() => {
		setUuidStyle(<style>
			{dialogs.map((e, i) => `.imp-z-index-${e.ids.length}-${e.ids[0]}{z-index: ${1100 + dialogs.length - i}!important;}`)}
		</style>)
	}, [dialogs])







	const [draggingId, setDraggingId] = useState(null)
	const [dragEvent, setDragEvent] = useState(null)
	const onDragDialog = (e) => {
		if (ENV === _ENV.PROD) {
			document.querySelectorAll('.event-details.dragging').forEach( d => {
				const scrollY = document.documentElement.style.getPropertyValue('--window-scroll')
				if (scrollY > 0) {
					d.style.top = (Number(d.style.top.replace('px', '')) + Number(scrollY)) + 'px'
				}
			})
		}
		setDragEvent(e)
	}
	

	
	
/*
 * MOVE TO FILTERS / UTILS
 */
	
// TEMP helper
const isRelativlyNotResolved = event => mapFiltersRef.current.isRelativlyNotResolved(event)
	
const eventIconName = (event) => 
	event._e === 't'
	? (isRelativlyNotResolved(event) ? 'emergency' : 'emergency-resolved')
	: event._m === 't'
	? (isRelativlyNotResolved(event) ? 'mass' : 'mass-resolved')
	: event.is_nuclear === '1'
	? 'atom-' + priority_colors[event.priority]
	:	industry_icon[event.industry] + '-' + priority_colors[event.priority]


	

	const title = (id) => {
		const event = DS.data.events.find(e => e.id === id)
		return <><p className="m-0 font-bold">{datetime(event.ds) + ' – '}{event.de ? datetime(event.de) : <span className="not-resolved">{' не завершено'}</span>}</p>{event.title.map((e, i) => <p key={i} className="m-0">{e}</p>)}</>
	}
	
	const [alerts, setAlerts] = useState([])
	useEffect(() => {
		const _alerts = []
		DS.data.deenergized.forEach(e => {
			let alert = _alerts.find(el => el.reg === e.region_code)
			if (!alert) {
				alert = {reg: e.region_code, sum: 0}
				_alerts.push(alert)
			}
			alert.sum += +e.population
		})
		_alerts.sort((a, b) => b.sum - a.sum)
		DS.setters.setHiddenAlerts(DS.data.hiddenAlerts.filter(h => _alerts.some(a => a.reg === h.reg && a.sum > DS.data.alertThreshLo && h.sum >= a.sum)))
		setAlerts(_alerts)
	}, [DS.data.deenergized])
	
	
	const hideAlert = (reg) => DS.setters.setHiddenAlerts([...DS.data.hiddenAlerts, {reg: reg, sum: alerts.find(e => e.reg === reg).sum}])
	const visibleAlert = (alert) => alert.sum >= DS.data.alertThreshHi && !DS.data.hiddenAlerts.some(el => el.reg === alert.reg)
	const [visibleAlerts, setVisibleAlerts] = useState([])
	useEffect(() => {
		setVisibleAlerts(alerts.filter(visibleAlert))
	}, [alerts, DS.data.alertThreshHi, DS.data.hiddenAlerts])
	useEffect(() => {
		const regions = new Set([...DS.userSettings.visiblePoweroff, ...visibleAlerts.map(e => e.reg)])
		DS.loadPoweroffs([...regions])
	}, [visibleAlerts])
	
	const progress = (reg) => {
		if (!DS.data.poweroff[reg]) return
		const len = DS.data.poweroff[reg].datasets[0].data.length
		if (len === 1) return DS.data.poweroff[reg].datasets[0].data[len-1].y
		return DS.data.poweroff[reg].datasets[0].data[len-1].y - DS.data.poweroff[reg].datasets[0].data[len-2].y
	}
	
	const miniGraph = (event, field, shutoffs) => {
		const data = {datasets: [{data: (shutoffs ?? DS.data.shutoffs.filter(s => s.uuid === event.id).sort((a, b) => a.m - b.m)).map(s => {return {
				x: s.m,
				y: s[field]
			}}) }]}
		
		if (data.datasets[0].data.length > 0) {
			let last = data.datasets[0].data[data.datasets[0].data.length-1].x
			if (event.rd && event.rd.isAfter(last)) {
				last = event.rd
				data.datasets[0].data.push({x: last, y: 0})
			}
			if (event.de && event.de.isAfter(last)) {
				last = event.de
				data.datasets[0].data.push({x: last, y: 0})
			}
			if (!event.rd && !event.de) {
				last = moment()
			}
			const first = event.ds.isBefore(data.datasets[0].data[0].x) ? event.ds : data.datasets[0].data[0].x
			return <div className={shutoffs ? 'nano-graph' : 'mini-graph'}>
				<Graph data={data} minDatetime={first} maxDatetime={last} mini={true} />
			</div>
		}
	}
	
	const massFields = {
		'ep': 'Точек поставки',
		'c' : 'Бытовых потребителей',
		'o' : 'Мощность, МВт (всего)',
		'ab': 'АВР бригад',
		'ip': 'АВР человек',
		'su': 'АВР ед. техники',
	}
	const fieldLabel = (code, label) => <div className={'clickable label py-1 pl-2 pr-3' + (DS.data.massGraphField === code ? ' active' : '')} onClick={() => DS.setters.setMassGraphField(code)} >{massFields[code]}</div>
	const tsoHeader = (tso, event) => {
		return <div className="flex align-items-center justify-content-between">
			<div className="">
				<span className={tso.id ? 'tso-name' : ''}>{tso.name} </span>
				{tso.id && <i className="pi pi-question-circle obj-link" onClick={e => {e.stopPropagation(); window.open(`https://справочник.сацминэнерго.рф/orgTable.php?id=${tso.id}`, '_blank')}}></i>}
			</div>
			<div className="flex align-items-center">
				{tso.data ? miniGraph(event, DS.data.massGraphField, tso.data) : <div className="nano-graph-stub"></div>}
				{!event.de &&
					<div className="number-1">
						{tso.data && tso.data[tso.data.length-1][DS.data.massGraphField]}
					</div>
				}
				<div className="number-1">
					{tso.data ? tso.data.map(e => e[DS.data.massGraphField]).reduce((a, e) => Math.max(a, e ?? 0), 0) : '—'}
				</div>
			</div>
		</div>
	}
	const summary = (field, event) => {
		const data = DS.data.shutoffs.filter(e => e.uuid === event.id).sort((a, b) => a.m - b.m).map(e => e[field])
		const max = data.reduce((a, e) => Math.max(a, e), 0)
		const last = data[data.length-1]
		return max > 0 && 
			<div className="grid mx-0 flex-nowrap">
				{fieldLabel(field)}
				{!event.de && <div className="number-1 py-1 font-bold">{last > 0 ? last : '—'}</div>}
				<div className={`number-${event.de ? '1' : '2 text-300'} py-1 font-bold`}>{max}</div>
				{miniGraph(event, field)}
			</div>
		
	}
	
	const [uuidStyle, setUuidStyle] = useState(<style></style>)
	
	const dialogHeader = (reg) => 
		reg.startsWith(deenergizedId) ? 'Обесточено населения: ' 
			+ (reg.endsWith('_all') ? DS.data.deenergized_sum : DS.data.deenergized.filter(e => reg.replace(deenergizedId, '') === e.region_code).map(e => e.population).reduce((a, e) => a + e, 0))
			+ ' абонентов (по данным компаний)'
		: reg.startsWith(fireRegId) ? 'Угрозы пожарной безопасности объектов ТЭК РФ'
		: reg.startsWith(weatherRegId) ? 'Прогноз погоды ' + DS.data.weatherForecastPeriod + ' ч'
		: null
	
	return <>
		
		<div className="map-filter _mod2 sticky-top">
			<div className="labels">
				<TopFilters ref={topFiltersRef} DS={DS} />
			</div>
		</div>

		<div className="alert-outer">
			<div className="alert-mid">
				<div className={'alert-inner'}>
					{DS.userSettings.mapOptions.powerOffThresh && alerts.filter(visibleAlert).map((e, i) => 
						<div key={i} className={'alert' + (i && DS.userSettings.showMapSettings ? ' op3' : ' op10')}>
							<div className="header flex align-items-center justify-content-between">
								{oktmo2name[code2region[e.reg].oktmo]}
								<i className="pi pi-times clickable" onClick={() => hideAlert(e.reg)}></i>
							</div>
							<div className="body">
								{e.sum} {progress(e.reg) < 0 ? <i className="pi pi-arrow-down text-success text-lg font-bold" /> : <i className="pi pi-arrow-up text-lg font-bold" />}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
		
		<div id="map-container" className="map-mod1" >
			{<MapFilters ref={mapFiltersRef} ENV={ENV} DS={DS} resetMapView={() => {
					mapRef.current.resetMap()
					setMapDivHeight(mapHeight())
					topFiltersRef.current.showMap()
				}}/>}
			<Map ref={mapRef} ENV={ENV} mapType={mapType} height={DS.filters.showMap ? mapDivHeight * mapScale : 0} mapScale={mapScale} 
				data={DS.data} filters={mapFiltersRef.current} dialogs={dialogs} _specobjects={DS?.filters?.period === 'Спецобъекты'}
				onShowEventDetails={onShowEventDetails} onShowObject={onShowObject} onShowDeenergized={onShowDeenergized} deenergizedId={deenergizedId} onShowFireReg={onShowFireReg} fireRegId={fireRegId} onShowWeatherReg={onShowWeatherReg}
			/>
		</div>
		
		<ASplitter visible={DS.filters.showMap} subjId="map-container" min={200} def={mapHeight()} setMapHeight={setMapDivHeight} mapScale={mapScale} />
		
		{uuidStyle}
		{DS.filters.showMap && dialogs.map((e, i) => <Dialog key={e.ids} 
				visible={true} modal={false} closeOnEscape={false} keepInViewport={false}
				className={'event-details' + (dialogs[0] === e ? ' highlighted' : '') + (draggingId === e ? ' dragging' : '') + (e.active.startsWith(fireRegId) ? ' fire-reg-dialog' : '') + (e.active.startsWith(weatherRegId) ? ' weather-reg-dialog' : '')}
				position="top"
				style={{position: 'fixed', top: ( ENV.extraScroll ? window.scrollY : 0 ) + ENV.defaultDialogTop + 'px'}}
				maskClassName={`imp-z-index-${e.ids.length}-${e.ids[0]}`}
				uuid={`${e.ids.length}-${e.ids[0]}`}
				appendTo={document.querySelector('#info-map-2')}
				onShow={() => onShowDialog(e)}
				onHide={() => onCloseDialog(e)}
				onClick={() => onDialogBringToFront(e)}
				onDragStart={() => {onDialogBringToFront(e); setDraggingId(e)}}
				onDragEnd={() => setDraggingId(null)} 
				onResizeStart={() => onDialogBringToFront(e)}
				onDrag={onDragDialog} 
				onResize={setDragEvent} 
				onDoubleClick={() => mapRef.current.centerTo(e.active)}
				header={dialogHeader(e.active)}
			>
				<div className="flex h-full">
					{e.ids.length > 1 && <div className="navbuttons col">
						{e.ids.map((id, i) => 
							<div key={i}>
								<Button className={'w-full text-left' + (id === e.active ? '' : ' p-button-outlined')} 
									label={title(id)} 
									onClick={() => onShowEventDetails([id])} 
								/>
							</div>
						)}
					</div>}
					{((id) => {
						if (id.startsWith(deenergizedId)) {
							return <Deenergized DS={DS} ENV={ENV} visibleAlerts={alerts.filter(visibleAlert)} region={id.replace(deenergizedId, '')} />
						} else if (id.startsWith(fireRegId)) {
							return <FireReg DS={DS} ENV={ENV} region={id.replace(fireRegId, '')} />
						} else if (id.startsWith(weatherRegId)) {
							return <WeatherReg DS={DS} ENV={ENV} region={id.replace(weatherRegId, '')}/>
						}
						
						const e = DS.data.events.find(e => e.id === id)
						
						const t = e.title_id.replace('{', '').replace('}', '').split(',').map(el => Number(el))
						const r = e.regions.replace('{', '').replace('}', '').split(',').map(el => Number(el))
						const i = e.ind.replace('{', '').replace('}', '').split(',').map(el => Number(el))
						if (!e.de) {
							const dur1 = DS.data.durations.filter(d => r.includes(d.r) && i.includes(d.i) && (e._m === (d._m ? 't' : 'f')))
							const dur2 = dur1.filter(d => t.includes(d.t))
							if (e.rd || !e.disabled_endpoints && !e.disabled_consumers && !e.cut_off_power) {
								e.forecastComplete = midDuration(dur2, 'com') ?? midDuration(dur1, 'com')
							} else {
								e.forecastPower = midDuration(dur2, 'pow') ?? midDuration(dur2, 'com') ?? midDuration(dur1, 'pow') ?? midDuration(dur1, 'com')
							}
						}

						return <div className="info col pr-3">

							<div className="info-header flex align-content-start justify-content-between">
								<div className="">
									<div className="flex align-items-center align-content-center flex-wrap">
										<img className="icon mr-2" src={`${ENV.imgUrl}${eventIconName(e)}.svg`} />
										<span className="flex ml-1 my-1 mr-3 align-items-center font-bold">{e.industry}</span>
										<div className="flex ml-0 my-1 align-items-center">
											<Badge value={e.priority} severity={priority_colors[e.priority]} />
										</div>
									</div>
									<div className="ml-2 mt-2">
										<div className="font-bold text-lg text-300">{e.regions.replace('{', '').replace('}', '').split(',').map((r, i) => oktmo2name[r].replaceAll(' ', ' ')).join(', ')}</div>
										<div className="">{e.title.map((t, i) => <p className="title" key={i}>{t}</p>)}</div>
									</div>
								</div>
								<div className="align-content-start align-items-center">
									<div className="flex justify-content-between">Начало <div className="datetime">{datetime(e.ds)}</div></div>
									{e.rd && <div className="flex justify-content-between">Восстановлено <div className="datetime">{datetime(e.rd)}</div></div>}
									<div className="flex justify-content-between">
										{e.de ? 'Завершено' : <div className="font-bold">{'Не завершено'}</div>}
										<div className="datetime">{e.de ? datetime(e.de) : daystime(moment().diff(e.ds) / 1000 / 60)}</div>
									</div>
									
									{e.forecastPower && <div className="mt-2">{'Среднее время восстановления'}</div>}
									{e.forecastPower && <div className="flex justify-content-between">{'по региону'}<div className="daystime">{daystime(e.forecastPower)}</div></div>}
									{e.forecastComplete && <div className="mt-2">{'Среднее время завершения'}</div>}
									{e.forecastComplete && <div className="flex justify-content-between">{'по региону'}<div className="daystime">{daystime(e.forecastComplete)}</div></div>}
								</div>
							</div>
							
							{(e.max_disabled_endpoints || e.max_disabled_consumers || e.max_cut_off_power) &&
								<div className="ml-2 event-shutoffs">
									<div className="grid my-2 mx-0 flex-nowrap">
										{e.de
											? <div className="title">{'Максимум отключений' + (e._m === 't' ? ' и хода АВР' : '') + ':'}</div>
											: <>
													<div className="title label">{'Отключения' + (e._m === 't' ? ' и ход АВР' : '') + ':'}</div>
													<div className="title number-1 pr-0">{'текущие'}</div>
													<div className="title number-2 pr-0">{'максимально'}</div>
												</>
										}
									</div>
									{(e.disabled_endpoints || e.max_disabled_endpoints) &&
										<div className="grid mx-0 flex-nowrap">
											{fieldLabel('ep')}
											{!e.de && <div className="number-1 py-1 font-bold">{e.disabled_endpoints || '—'}</div>}
											<div className={`number-${e.de ? '1' : '2 text-300'} py-1 font-bold`}>{e.max_disabled_endpoints}</div>
											{miniGraph(e, 'ep')}
										</div>
									}
									{(e.disabled_consumers || e.max_disabled_consumers) &&
										<div className="grid mx-0 flex-nowrap">
											{fieldLabel('c')}
											{!e.de && <div className="number-1 py-1 font-bold">{e.disabled_consumers || '—'}</div>}
											<div className={`number-${e.de ? '1' : '2 text-300'} py-1 font-bold`}>{e.max_disabled_consumers}</div>
											{miniGraph(e, 'c')}
										</div>
									}
									{(e.cut_off_power || e.max_cut_off_power) &&
										<div className="grid mx-0 flex-nowrap">
											{fieldLabel('o')}
											{!e.de && <div className="number-1 py-1 font-bold">{e.cut_off_power ? Number(e.cut_off_power.toFixed(3)) : '—'}</div>}
											<div className={`number-${e.de ? '1' : '2 text-300'} py-1 font-bold`}>{e.max_cut_off_power ? Number(e.max_cut_off_power.toFixed(3)) : 'null'}</div>
											{miniGraph(e, 'o')}
										</div>
									}
									{summary('ab', e)}
									{summary('ip', e)}
									{summary('su', e)}
									
								</div>
							}

							{true &&
								<div className="ml-2 event-objects">
									<div className="title mt-2">{'Объекты ТЭК:'}</div>
									<ul>
										{e.ka_object_uuid2name.substring(2, e.ka_object_uuid2name.length-2).split('","').map((s, i) => <li key={i}>
											{(() => {
												const obj = DS.data.objCache[e.ka_object_uuid.substring(1, e.ka_object_uuid.length-1).split(',')[i].toUpperCase()]
												return <div className="">
													{obj && obj.latlng
														? <a className={'obj-link' + (obj.uuid === dialogs[0].objuuid ? ' highlighted' : '')} onClick={() => onShowObject(obj.uuid)}>{s}</a>
														: <span>{s}</span>
													}
													{obj && <i className="ml-2 pi pi-question-circle obj-link" onClick={() => objDBTable(obj.type) && window.open(`https://справочник.сацминэнерго.рф/objectTable.php?objectType=${objDBTable(obj.type)}&uuid=${obj.uuid}`, '_blank')}></i> }
													</div>
											})()}
										</li>)}
									</ul>
								</div>
							}
							
							{e._m === 't' && DS.data.tso[e.regionId] &&
								<div className="ml-2 event-objects">
									<div className="title mt-2 flex justify-content-between">
										<div className="">{'ТСО:'}</div>
										<div className="flex">
											<div className="font-normal">{massFields[DS.data.massGraphField]}</div>
											{!e.de &&
												<div className="number-1">{'тек'}</div>
											}
											<div className="number-1">{'макс'}</div>
										</div>
									</div>
									<ul>
										<Accordion multiple className="mini-accordion">
											{((event) => {
												const shutoffs = 
													DS.data.shutoffs.filter(e => e.uuid === event.id).map(s => {
														const st = DS.data.shutoff_tso.filter(t => t.uuid === s.uuid && t.m.isSame(s.m))
														return st.length > 0 ? st : [Object.assign({}, s, (() => {
															const org = DS.data.def_org.find(e => e.uuid === s.uuid)
															return org && {tso_id: org.id, tso_name: org.id === null ? org.name : null}
														})())]
													}).reduce((a, e) => [...a, ...e], [])
												const tsos = shutoffs.map(s => {
														return {id: s.tso_id, name: s.tso_name ?? DS.data.tso[event.regionId].find(t => t.id === s.tso_id)?.name}
													}).reduce((a, e) => a.some(t => t.id === e.id && t.name === e.name) ? a : [...a, e], [])
												const orgs = [...DS.data.tso[event.regionId]]
												tsos.forEach(t => {
													if (t.id === null || !orgs.map(e => e.id).includes(t.id)) orgs.push(t.id === null ? t : DS.data.orgs.find(e => e.id === t.id))
												})
												orgs.forEach(o => {
													const data = shutoffs.filter(e => e.tso_id && e.tso_id === o.id || e.tso_id === null && e.tso_name === o.name).sort((a, b) => a.m - b.m)
													if (data.length) o.data = data
												})
												return orgs
											})(e).map((tso, i) =>
												<AccordionTab key={i} header={tsoHeader(tso, e, 'ep')} disabled={tso.id === null} pt={{root: {className: 'p-accordion-tab' + (tso.ix ? '' : ' extra')}}}>
													{(tso.email || tso.phone1 || tso.phone2 || tso.file) ? <>
														{tso.file && <div className="ml-3"><a className="download" href={tso.file} target="_blank"><i className="fas fa-lg fa-file-pdf mr-2"></i>{'Контакты ответственных лиц'}</a></div>}
														<div className="ml-3">{tso.email}</div>
														<div className="ml-3">{tso.phone1 ?? tso.phone2}</div>
													</> : <div className="ml-3">{'контактная информация отсутствует'}</div>
													}
												</AccordionTab>
											)}
										</Accordion>
									</ul>
								</div>
							}
							
							{(e._m === 't' && e.de === null) && !DS.data.prevMass.some(el => el.id === e.id) && DS.loadPrevMass(e.id)}
							{(e._m === 't' && e.de === null) && DS.data.prevMass.filter(el => el.id === e.id).map(p => <Panel key={0} className="mt-3 description" header="Предыдущие массовые в регионе" toggleable collapsed>
								<div className="flex font-bold">
									<div className="p-0 col-2">{'Начало'}</div>
									<div className="p-0 number-1 text-right">{'Длит.'}</div>
									<div className="p-0 number-1">{'Чел'}</div>
									<div className="p-0 number-1">{'Точ.П'}</div>
									<div className="p-0 number-1">{'МВт'}</div>
									<div className="p-0 number-1">{'Бриг'}</div>
									<div className="p-0 number-1">{'Чел'}</div>
									<div className="p-0 number-1">{'Ед.Т'}</div>
								</div>
								{p.prevMass.map((e, i) => <div key={i} className="flex">
									<div className="p-0 col-2">
										<a className="obj-link" href={`https://журнал.сацминэнерго.рф/?e=${e.uuid}`} target="_blank" title="Открыть в Журнале">{date(e.ds)}</a>
									</div>
									<div className="p-0 number-1 text-right">{daystime((e.de || moment()).diff(e.ds) / 1000 / 60)}</div>
									<div className="p-0 number-1">{e.c}</div>
									<div className="p-0 number-1">{e.ep}</div>
									<div className="p-0 number-1">{(e.ot).toFixed(3)}</div>
									<div className="p-0 number-1">{e.ab}</div>
									<div className="p-0 number-1">{e.ip}</div>
									<div className="p-0 number-1">{e.su}</div>
								</div>)}
							</Panel>)}
							
							<Panel className="mt-3 description" header="Описание" toggleable collapsed >
								<div dangerouslySetInnerHTML={{ __html: fixHtml(e.description) }}></div>
							</Panel>
							
							<div className="mx-2 mt-2">
								<a className="obj-link" href={`https://журнал.сацминэнерго.рф/?e=${e.id}`} target="_blank">Открыть в Журнале</a>
							</div>
							
						</div>
					})(e.active)
					}
				</div>
			</Dialog>
		)}
		
		{ DS?.filters?.period === 'Спецобъекты'
			? <div id="a-content mt-3"><div className="hr"></div></div>
			: <div id="a-content">
					<TotalInfo deenergized={DS.data.deenergized} deenergized_sum={DS.data.deenergized_sum} panels={DS.data.panels} onShowDeenergized={onShowDeenergized} />
					<div className="hr"></div>
					<Table data={DS.data} ENV={ENV} eventIconName={eventIconName} dialogs={dialogs} onShowEventDetails={onShowEventDetails}/>
				</div>
		}
		
	</>
	
}

